import ExampleOldDeckGL from './ExampleOldDeckGL';

export default ExampleOldDeckGL;
